module.exports = __webpack_public_path__ + "img/renl.61feddd4.png";